export const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('ru-RU', {
        currency: 'KZT',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};
